import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import bitmap from '../../../assets/static/images/bitmap.png'
import { getDefaultTextLogo, humanize } from '../../../itrust_common/components/HelperFunctions';
import DateFormatView from '../../../itrust_common/components/others/DateFormatView';

export default function PatientSignUp(props) {
  const { currentUser, meta, organisation, patient: { signup_steps } } = props
  const [isVisible, setIsVisible] = useState(currentUser.has_scheduled_appointment)
  const dispatch = useDispatch()

  const handleGetWizardSteps = () => {
    let completedCount = 0;
    for (const step in signup_steps) {
      if (signup_steps.hasOwnProperty(step) && signup_steps[step]) {
        completedCount++;
      }
    }
    return 5 - completedCount;
  }

  return (
    <div className={`modal bg-light ${!meta.one_click_login && isVisible && !signup_steps?.completed && 'd-block'}`} style={{ zIndex: 999999999 }} id="patient-signup-modal" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog mx-auto mt-9 pt-9" role="document">
        <div className="modal-content shadow-lg">
          <div className="modal-header flex-column bg-info-light text-center align-items-center">
            <span className="d-block badge py-3">
              {getDefaultTextLogo(organisation, 'width-6', 'py-4')}
            </span>
          </div>
          <div className="modal-body p-6">
            <div className="d-flex align-items-center mb-5">
              <img src={bitmap}></img>
              <h6 className="pl-5">{humanize(currentUser.name)}</h6>
            </div>
            <span>
              You have <strong>{handleGetWizardSteps()}</strong> steps left to complete your sign up for appointment on <DateFormatView dateTime={currentUser.nearest_future_appointment} />
            </span>
            <div className="text-right pt-7">
              <Link exact to={`/patients/${currentUser.id}/account_information`} className="btn btn-dark ml-5" onClick={() => setIsVisible(false)}>Continue Now</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
